<template>
  <div :class="isChkLoading ? '' : 'full-background'" style="position: relative; z-index: 1; height: 100%">
    <router-view />
    <upload-progress></upload-progress>
  </div>
</template>

<script>
import UploadProgress from '@/views/meeting/component/record/UploadProgress.vue'
export default {
  components: {
    UploadProgress,
  },
  name: 'App',
  // created() {
  //   let storedLanguage = null

  //   try {
  //     storedLanguage = localStorage.getItem('Language')
  //   } catch (e) {
  //     console.log(e)
  //   }

  //   if (storedLanguage && storedLanguage !== null) this.$i18n.locale = storedLanguage
  //   else this.$i18n.locale = navigator.language === 'ko' ? 'ko' : 'en'
  // },
  computed: {
    isChkLoading() {
      return this.$store.getters.chk_isLoading
    },
  },
}
</script>

<style>
@import './assets/css/NotoSansKR-Hestia.css';
@import './assets/css/common.css';
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');

*:not(.video-js *, [class*=' el-icon-'], [class^='el-icon-'], .material-icons, .material-icons-round) {
  font-family: 'Inter', 'Noto Sans KR', 'Apple SD Gothic Neo', 'Malgun Gothic', sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: none;
}

.btn-able {
  color: #fff !important;
  background-color: var(--v-tapeGreen-base) !important;
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg.btn-disable {
  color: #fff !important;
  background-color: #96a7af !important;
}
/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* width */
::-webkit-scrollbar {
  height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(71, 94, 105, 0.3);
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(71, 94, 105, 0.8);
}

.el-notification.right {
  background-color: #31434f;
  border-color: #31434f;
}

.el-notification__title {
  color: white !important;
}

.el-notification__content {
  color: #96a7af !important;
}
.full-background {
  background-color: #25343a;
}
@media (max-width: 959px) {
  .full-background {
    /* overflow: hidden; */
  }
}
</style>
